import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgEnvelope = (props: SvgProps) => (
  <Svg fill="none" height={25} width={25} {...props}>
    <Path
      clipRule="evenodd"
      d="M.789 7.148a.1.1 0 0 0-.16.081v12.498a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V7.229a.1.1 0 0 0-.158-.08l-10.665 7.756a2 2 0 0 1-2.353 0zM24.026 5a.096.096 0 0 0 .013-.146 2 2 0 0 0-1.41-.58h-20c-.549 0-1.047.221-1.408.58A.096.096 0 0 0 1.234 5l11.396 8.288z"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgEnvelope);
export default Memo;
